import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ViewInvoicesComponent } from './view-invoices.component';
import { SharedModule } from '../../shared/shared.module';
import { MatListModule } from '@angular/material';

const routes: Routes = [
  { path: '', component: ViewInvoicesComponent },
];

@NgModule({
  declarations: [
    ViewInvoicesComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    MatListModule,
    RouterModule.forChild(routes)
  ],
  providers: [],
  entryComponents: [],
  bootstrap: [],
  exports: [RouterModule]
})
export class ViewInvoicesModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-invoices/view-invoices.module.ts